import React, { useContext } from 'react'
import FlexView from 'react-flexview/lib'
import dji from '../../assets/dji.png'
import airdata from '../../assets/airdata.png'
import {
  TextField,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  useMediaQuery,
  GridList,
  GridListTile,
  Grid,
} from '@material-ui/core'
import { SessionContextStore } from '../../context/SessionContext'
import { useForm } from 'react-hook-form'
import { TextButton } from '../Core/Buttons/TextButton'
import CloudUploadIcon from '@material-ui/icons/CloudUpload'
import NewFillButton from '../Core/NewFillButton'
import { getSupportMail, awaitWithLoading } from '../../services/utils'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import FileUpload from '../Core/FileUpload'
import discountsApi from '../../api/discounts.api'
import { EMAIL_REGEX } from '../../Constants'
import {
  EventEmitterService,
  EventKey,
} from '../../services/EventEmitterService'
import { UploadFlightLogsPopup } from '../PopUps/UploadFlightLogsPopup'
const classnames = require('classnames')

const SUPPORTED_FORMATS_IMAGES = [
  'air_data',
  'drone_deploy',
  'freefly',
  'litchie',
  'maps_made_easy',
  'parrot',
  'yunnec',
]

export const FlightLogs = () => {
  const sessionContext = useContext(SessionContextStore)
  const [uploadSuccess, setUploadSuccess] = React.useState(false)
  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    watch,
    control,
    errors,
    getValues,
  } = useForm({
    defaultValues: { email: sessionContext.user.email },
    mode: 'onChange',
  })
  const isMobile = !useMediaQuery((theme) => theme.breakpoints.up('lg'))
  const emailWatch = watch('email')

  React.useEffect(() => {
    setValue('email', sessionContext.user.email)
  }, [sessionContext.user])

  const onUpload = async (files, onSuccess, onError, onProgress) => {
    let valid = await trigger()

    if (!valid || files.length == 0) return

    if (files.length < 5)
      EventEmitterService.dispatch(
        EventKey.FLIGHT_LOGS_MORE_LOGS_POPUP_SHOW,
        () => {
          uploadFlightLogs(files, onSuccess, onError, onProgress)
        }
      )
    else uploadFlightLogs(files, onSuccess, onError, onProgress)
  }

  async function uploadFlightLogs(files, onSuccess, onError, onProgress) {
    let res = await awaitWithLoading(
      discountsApi.uploadFlightLogs(
        getValues()['email'],
        files,
        () => {
          onSuccess()
          setUploadSuccess(true)
        },
        onError,
        onProgress
      )
    )
  }

  const reset = () => setUploadSuccess(false)

  return (
    <FlexView>
      <div>
        <div className="text-title bold black margin-top-basic">
          Upload flight logs
        </div>
        <div
          className={classnames('margin-top-basic', {
            textcenter: isMobile,
          })}>
          Upload your drone flight and logs to get your risk analysis{' '}
        </div>

        {!uploadSuccess && (
          <>
            <FlexView
              vAlignContent={'center'}
              className="margin-top-basic margin-bottom-basic">
              <FlexView column>
                <div className="text-title bold blue margin-top-basic">
                  Step 1
                </div>
                <div className="text-body black margin-top-6">
                  Enter your email
                </div>
                <TextField
                  fullWidth
                  variant="outlined"
                  className="margin-top-basic flight-logs-email"
                  autoComplete="email"
                  InputLabelProps={{
                    shrink: !!sessionContext.user.email || !!emailWatch,
                  }}
                  label="Email"
                  type="email"
                  name="email"
                  inputRef={register({
                    required: true,
                    pattern: {
                      value: EMAIL_REGEX,
                      message: 'Invalid email address',
                    },
                  })}
                  helperText={
                    !!errors.email &&
                    (errors.email.message || errors.email.type)
                  }
                  error={!!errors.email}
                />
              </FlexView>
            </FlexView>
            <div className="text-title bold blue margin-top-medium">Step 2</div>
            <div className="text-body black margin-top-6 margin-bottom-basic">
              Upload at least{' '}
              <span className="bold">5 flight log files of 5 minutes</span> to
              get an inital safety score discount
            </div>
          </>
        )}
        <div className="fit-content">
          <FileUpload
            fileFilter={['.txt', '.csv', '.dat', '.log']}
            uploadEnabled={!errors.email}
            onUpload={onUpload}
            successComponenet={
              <div className="margin-top-basic">
                <div className="text-body bold black">
                  We are crunching the numbers right now and we will get back to
                  you with an offer soon
                </div>
              </div>
            }
            reset={reset}
            resetStateText={'Back to flights upload'}
          />
        </div>

        <div className="text-body black margin-top-small margin-bottom-6">
          The formats we support:
        </div>

        <GridList cols={3} cellHeight={50}></GridList>

        <Grid container spacing={3}>
          {SUPPORTED_FORMATS_IMAGES.map((fmt) => (
            <Grid item>
              <img
                src={`${process.env.PUBLIC_URL}/assets/flightlogs/${fmt}.png`}
                className="logs-supported"
              />
            </Grid>
          ))}
        </Grid>

        <div className="margin-top-small text-small grey margin-top-medium">
          Need Help ?{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://faq.skywatch.ai/hc/en-us/articles/360025271611-How-do-I-retrieve-my-DJI-Go-flight-logs-from-from-my-IOS-device-"
            className=" clickable blue underline">
            How to retrieve DJI logs
          </a>
          ,<span>&nbsp;&nbsp;</span>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://faq.skywatch.ai/hc/en-us/articles/360010451499-Sharing-AirData-logs-"
            className=" clickable blue underline">
            How to retrieve Airdata logs
          </a>
        </div>

        <div className="text-small grey margin-top-6">
          Using other apps? Contact{' '}
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={getSupportMail()}
            className="blue clickable underline">
            support@skywatch.ai
          </a>
        </div>

        <div className="text-small grey margin-top-6">
          Submitted flight logs are used for analysis and research purposes only
          and will not be shared with any 3rd party entity
        </div>
        <Accordion elevation={0} className="margin-top-medium transparent">
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <div className="text-body gray">How does it work ?</div>
          </AccordionSummary>
          <AccordionDetails>
            <ul className="text-small gray">
              <li>Upload your flight logs to our portal</li>
              <li>
                Our algorithm will assess multiple parameters within your
                flights such as weather, flight altitude, flight area and more
              </li>
              <li>
                Each flight will get a Safety Score based on its performance
              </li>
              <li>
                Your rating will be calculated as an average of all of your
                flights scores together
              </li>
              <li>
                You’ll get an email with your Safety Score and a link which you
                can use to activate your discount
              </li>
            </ul>
          </AccordionDetails>
        </Accordion>
      </div>
      {!isMobile && (
        <img
          className="flight-logs-img"
          src={process.env.PUBLIC_URL + '/assets/image-flight-logs.png'}
        />
      )}

      <UploadFlightLogsPopup />
    </FlexView>
  )
}
